module.exports = __webpack_public_path__ + "img/back.c2b1f229.svg";